import React from "react";
import { motion } from "framer-motion";
import "./Newsletter.css";
import {
    Headphones,
    Phone,
    Mail,
    MapPin
} from "lucide-react";
const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
};

export default function Newsletter() {
    return (
        <footer className="ft-wrapper">

            {/* TOP INFO ROW */}
            <motion.div
                className="ft-top"
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.2 }}
                transition={{ staggerChildren: 0.15 }}
            >
                <motion.div className="ft-item" variants={fadeUp}>
                    <span className="ft-icon-wrap">
                        <Headphones className="ft-icon-filled" />
                    </span>
                    <div>
                        <p className="ft-title">Customer Support</p>
                        <p className="ft-sub">9:30 AM – 5:30 PM IST</p>
                    </div>
                </motion.div>

                <motion.div className="ft-item" variants={fadeUp}>
                    <span className="ft-icon-wrap">
                        <Phone className="ft-icon-filled" />
                    </span>
                    <div>
                        <p className="ft-title">Call Us</p>
                        <p className="ft-sub">+91 72044 29777</p>
                    </div>
                </motion.div>

                <motion.div className="ft-item" variants={fadeUp}>
                    <span className="ft-icon-wrap">
                        <Mail className="ft-icon-filled" />
                    </span>
                    <div>
                        <p className="ft-title">Email</p>
                        <p className="ft-link">swarnaprakashjewellers@gmail.com</p>
                    </div>
                </motion.div>

                <motion.div className="ft-item" variants={fadeUp}>
                    <span className="ft-icon-wrap">
                        <MapPin className="ft-icon-filled" />
                    </span>
                    <div>
                        <p className="ft-title">Visit Store</p>
                        <p className="ft-sub">
                            Swarna Prakash Jewellers,
                            Joduraste, Karkala<br />
                            Udupi District – 576117
                        </p>
                    </div>
                </motion.div>
            </motion.div>

            {/* NEWSLETTER */}
            {/* <motion.div
                className="ft-news"
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.3 }}
                transition={{ staggerChildren: 0.15 }}
            >
                <motion.h2 variants={fadeUp} className="ft-news-title">
                    Join Our Newsletter
                </motion.h2>
                <motion.p variants={fadeUp} className="ft-news-sub">
                    Sign up to our newsletter & be the first to hear about launches, events & exclusive update
                </motion.p>

                <motion.div variants={fadeUp} className="ft-input-row">
                    <input type="email" placeholder="Enter your email" className="ft-input" />
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.96 }}
                        className="ft-btn"
                    >
                        Sign Up
                    </motion.button>
                </motion.div>

                <motion.p variants={fadeUp} className="ft-terms">
                    By subscribing you agree to the Terms of Services and Privacy Policy.
                </motion.p>
            </motion.div> */}

            {/* BOTTOM LINKS */}
          

        </footer>
    );
}
